const mustBeCool = {
  $validator: (value) => value.includes("cool"),
  $message: "test cool",
};

export default mustBeCool;
